const CopyText = (link) => navigator.clipboard.writeText(link);

export default CopyText;
